import React from "react";

export interface INACellProps {
  getValue: any;
  className?: string;
}

const NACell: React.FC<INACellProps> = (props) => {
  const { getValue, className } = props;
  const value = getValue();
  return <>{getValue() ? getValue() : "N/A"}</>;
};

export default NACell;